import React, { useCallback, useContext, useRef, useState } from 'react';
import { setYearAnalyticsUser } from './yearAnalyticsAccessCache';

const UserContext = React.createContext();

const UserProvider = (props) => {
	//   const user = {} || JSON.parse(localStorage.getItem('user'))
	//   const setUser = useAuth().data.setUser
	// const _user = JSON.parse(localStorage.getItem('user')) || {};
	const [user, updateUser] = useState({});
	const userRef = useRef(user);
	const setUser = useCallback((value) => {
		const nextUser = typeof value === 'function' ? value(userRef.current) : value;
		setYearAnalyticsUser(nextUser);
		userRef.current = nextUser;
		updateUser(nextUser);
	}, []);
	const isSignedIn = !!user?.email;

	return <UserContext.Provider value={{ user, setUser, isSignedIn }} {...props} />;
};

function useUser() {
	const context = useContext(UserContext);

	if (context === undefined) {
		throw new Error(`useUser must be used within a UserProvider`);
	}

	return context;
}

export { UserProvider, useUser };
